import { arrayMove } from "@dnd-kit/sortable";

export const reorderArray = <T>(items: T[], from: number, to: number): T[] =>
  arrayMove(items, from, to);
